<ng-container *ngIf="!isUserOnFreeMinutesBillingVersion; else secondBillingVersion">
    <div class="number-wrapper d-flex align-items-center justify-content-between is-initial-billing-version">
        <div class="d-flex justify-content-center align-items-center title-wrapper">
            <div class="title">{{ 'COMMON.ROSIE_NUMBER' | translate }}</div>
            <img class="special-arrow" [src]="'assets/images/special-arrow.svg'">
        </div>
        <div class="number-input">
            <div class="number">{{agentPhoneNumber | phoneNumber }}</div>
            <rosie-button [customClass]="'action narrow slimmer text-sm'"
                [translationKey]="hasCopiedValue ? 'COMMON.COPIED' : 'COMMON.COPY'"
                [iconPrefixConfig]="{name: 'heroSquare2Stack', size: '20px', strokeWidth: '2', color: '#822ac6'}"
                (click)="copyFieldValue()"></rosie-button>
        </div>
    </div>
</ng-container>
<ng-template #secondBillingVersion>
    <div class="number-wrapper d-flex align-items-center justify-content-between is-second-billing-version">
        <div class="title-wrapper">
            <div class="title">{{ 'COMMON.USE_ROSIE_NUMBER' | translate }}</div>
            <div class="description">{{ 'COMMON.USE_ROSIE_NUMBER_DESCRIPTION' | translate }}</div>
        </div>
        <img class="special-arrow" [src]="'assets/images/special-arrow.svg'">
        <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="number-input">
                <div class="number">{{agentPhoneNumber | phoneNumber }}</div>
                <rosie-button [customClass]="'action narrow slimmer text-sm'"
                    [translationKey]="hasCopiedValue ? 'COMMON.COPIED' : 'COMMON.COPY'"
                    [iconSuffixConfig]="{name: 'heroSquare2Stack', size: '20px', strokeWidth: '2', color: '#822ac6'}"
                    (click)="copyFieldValue()"></rosie-button>
            </div>
            <div class="request-code request-code-intercom" (click)="onRequestLocalAreaCodeClicked()">{{
                'COMMON.REQUEST_CODE' | translate }}</div>
        </div>
    </div>
</ng-template>